import { typography } from '../global/typography';
import type { ComponentOverride } from '../types';

export const MuiAlertTitle: ComponentOverride<'MuiAlertTitle'> = {
  MuiAlertTitle: {
    styleOverrides: {
      root: {
        marginTop: 0,
        ...typography.subtitle1,
      },
    },
  },
};
